import React from "react";
import "../scss/heading.scss";

const Heading = ({ number, text, id }) => {
  return (
    <div id={id} className="heading">
      <span></span>
      <h3>{number}</h3>
      <h2>{text}</h2>
    </div>
  );
};

export default Heading;
